module.exports = __webpack_public_path__ + "static/media/tese_romeu.c37b21fa.png";